import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import MyBetsContainer from './MyBets/MyBetsContainer.jsx';
import NewBetsContainer from './NewBets/NewBetsContainer.jsx';
import { handleShowOffer } from '../../helpers/utils';

class BetsTablesContainer extends PureComponent {
  handleOfferDetails = (id, whichFolder) => {
    const { history, match } = this.props;
    const isTextNotSelected = window.getSelection().toString() === '';
    if (isTextNotSelected) {
      handleShowOffer(id, history, match, whichFolder);
    }
  }
  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Redirect from="/dashboard/bets" exact to="/dashboard/bets/my" />
        <Route exact path={`${match.url}/my`}>
          <MyBetsContainer
            handleShowOffer={this.handleOfferDetails}
          />
        </Route>
        <Route exact path={`${match.url}/new`}>
          <NewBetsContainer
            handleShowOffer={this.handleOfferDetails}
          />
        </Route>
      </Switch>
    );
  }
}

BetsTablesContainer.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default BetsTablesContainer;
